export class CognitoExchangeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountDomain",
            "baseName": "eonAccountDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "grantType",
            "baseName": "grantType",
            "type": "CognitoExchangeRequestGrantTypeEnum",
            "format": ""
        },
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "redirectUri",
            "baseName": "redirectUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "refreshToken",
            "baseName": "refreshToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "codeVerifier",
            "baseName": "codeVerifier",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CognitoExchangeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var CognitoExchangeRequestGrantTypeEnum;
(function (CognitoExchangeRequestGrantTypeEnum) {
    CognitoExchangeRequestGrantTypeEnum["AuthorizationCode"] = "authorization_code";
    CognitoExchangeRequestGrantTypeEnum["RefreshToken"] = "refresh_token";
})(CognitoExchangeRequestGrantTypeEnum || (CognitoExchangeRequestGrantTypeEnum = {}));
